module.exports = __webpack_public_path__ + "img/NCC2040_R.db44e997.png";